module.exports = __webpack_public_path__ + "img/record-bac-active.09ec6551.png";